import OverallDevelopmentResultItem from './model';

export default OverallDevelopmentResultItem;



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/OverallDevelopment/result/items/index.js